import {connect} from 'react-redux';

import IngestData from './IngestData';
import {
    setIngestDataAction,
    resetIngestDataAction,
    putIngestDataAction,
} from './Redux/IngestDataActions';
import {IngestDataState} from './IngestDataTypes';

export type State = {
    ingest: {
        ingestData: IngestDataState
    }
};

export const mapState = (state: State): IngestDataState => {
    const {ingest} = state;
    const {ingestData} = ingest;

    return ingestData;
};

export const mapDispatch = {
    setIngestData: setIngestDataAction,
    resetIngestData: resetIngestDataAction,
    putIngestData: putIngestDataAction,
};

export default connect(mapState, mapDispatch)(IngestData);
